export const ENTRY_GUIDE_PRINT_STYLES = `
  .eg-print-root * { box-sizing: border-box; }
  .eg-print-root {
    font-family: Helvetica, Arial, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    font-size: 9pt;
    color: #374151;
    line-height: 1.3;
    background: white;
  }
  .eg-print-root .print-container {
    background: white;
    padding: 10mm;
    width: 210mm;
    min-height: auto;
  }
  .eg-print-root .doc-title {
    text-align: center;
    font-size: 12pt;
    font-weight: 700;
    color: #0d9488;
    margin: 0 0 2px 0;
    text-transform: uppercase;
    letter-spacing: 0.2px;
  }
  .eg-print-root .doc-title-rule {
    height: 0;
    border: none;
    border-top: 0.5mm solid #0d9488;
    margin: 0 0 4mm 0;
  }
  .eg-print-root .info-line {
    font-size: 7.5pt;
    color: #374151;
    margin-bottom: 3px;
    line-height: 1.35;
    word-wrap: break-word;
  }
  .eg-print-root .info-label {
    font-weight: 700;
    color: #0d9488;
  }
  .eg-print-root .info-sep {
    color: #9ca3af;
    margin: 0 2px;
  }
  .eg-print-root .status-badge {
    display: inline-block;
    padding: 0 4px;
    border-radius: 2px;
    font-size: 6pt;
    font-weight: 700;
    vertical-align: middle;
    margin-left: 2px;
  }
  .eg-print-root .status-issued { background: #d1fae5; color: #065f46; }
  .eg-print-root .status-open { background: #fef3c7; color: #92400e; }
  .eg-print-root .status-completed { background: #dbeafe; color: #1e40af; }
  .eg-print-root .status-cancelled { background: #fee2e2; color: #991b1b; }
  .eg-print-root .refs-block { margin: 3px 0 5px 0; }
  .eg-print-root .refs-title {
    font-size: 7pt;
    font-weight: 700;
    color: #0d9488;
    margin-bottom: 2px;
    padding-bottom: 1px;
    border-bottom: 0.3mm solid #0d9488;
    display: inline-block;
  }
  .eg-print-root .ref-line {
    font-size: 7.5pt;
    color: #374151;
    margin-bottom: 2px;
    line-height: 1.3;
  }
  .eg-print-root .section-title {
    font-size: 8pt;
    font-weight: 700;
    color: #0d9488;
    text-transform: uppercase;
    margin: 4px 0 3px 0;
    padding-bottom: 1px;
    border-bottom: 0.3mm solid #0d9488;
    display: inline-block;
  }
  .eg-print-root .items-section {
    margin-top: 2px;
  }
  .eg-print-root .items-table-wrap {
    margin-top: 0;
  }
  .eg-print-root .items-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 6pt;
    table-layout: fixed;
    margin-top: 2px;
    line-height: 1.2;
  }
  .eg-print-root .items-table thead { background: #0d9488; color: white; }
  .eg-print-root .items-table th {
    padding: 2px 3px;
    text-align: left;
    font-weight: 700;
    font-size: 6pt;
    border: 0.15mm solid #e5e7eb;
  }
  .eg-print-root .items-table td {
    padding: 2px 3px;
    border: 0.15mm solid #e5e7eb;
    color: #374151;
    vertical-align: middle;
    word-wrap: break-word;
  }
  .eg-print-root .items-table tbody tr:nth-child(even) td { background: #f9fafb; }
  .eg-print-root .items-table .num { text-align: right; white-space: nowrap; }
  .eg-print-root .items-table .center { text-align: center; white-space: nowrap; }
  .eg-print-root .items-table .subtotal-cell { font-weight: 700; text-align: right; white-space: nowrap; }
  .eg-print-root .items-table.cols-5 th:nth-child(1),
  .eg-print-root .items-table.cols-5 td:nth-child(1) { width: 51%; }
  .eg-print-root .items-table.cols-5 th:nth-child(2),
  .eg-print-root .items-table.cols-5 td:nth-child(2) { width: 7%; text-align: center; }
  .eg-print-root .items-table.cols-5 th:nth-child(3),
  .eg-print-root .items-table.cols-5 td:nth-child(3) { width: 10%; }
  .eg-print-root .items-table.cols-5 th:nth-child(4),
  .eg-print-root .items-table.cols-5 td:nth-child(4) { width: 11%; }
  .eg-print-root .items-table.cols-5 th:nth-child(5),
  .eg-print-root .items-table.cols-5 td:nth-child(5) { width: 21%; }
  .eg-print-root .items-table.cols-6 th:nth-child(1),
  .eg-print-root .items-table.cols-6 td:nth-child(1) { width: 35%; }
  .eg-print-root .items-table.cols-6 th:nth-child(2),
  .eg-print-root .items-table.cols-6 td:nth-child(2) { width: 7%; text-align: center; }
  .eg-print-root .items-table.cols-6 th:nth-child(3),
  .eg-print-root .items-table.cols-6 td:nth-child(3) { width: 15%; }
  .eg-print-root .items-table.cols-6 th:nth-child(4),
  .eg-print-root .items-table.cols-6 td:nth-child(4) { width: 10%; }
  .eg-print-root .items-table.cols-6 th:nth-child(5),
  .eg-print-root .items-table.cols-6 td:nth-child(5) { width: 11%; }
  .eg-print-root .items-table.cols-6 th:nth-child(6),
  .eg-print-root .items-table.cols-6 td:nth-child(6) { width: 22%; }
  .eg-print-root .items-table.cols-ventas-progress th:nth-child(1),
  .eg-print-root .items-table.cols-ventas-progress td:nth-child(1) { width: 11%; }
  .eg-print-root .items-table.cols-ventas-progress th:nth-child(2),
  .eg-print-root .items-table.cols-ventas-progress td:nth-child(2) { width: 34%; }
  .eg-print-root .items-table.cols-ventas-progress th:nth-child(3),
  .eg-print-root .items-table.cols-ventas-progress td:nth-child(3) { width: 10%; }
  .eg-print-root .items-table.cols-ventas-progress th:nth-child(4),
  .eg-print-root .items-table.cols-ventas-progress td:nth-child(4) { width: 11%; }
  .eg-print-root .items-table.cols-ventas-progress th:nth-child(5),
  .eg-print-root .items-table.cols-ventas-progress td:nth-child(5) { width: 22%; }
  .eg-print-root .items-table.cols-ventas-progress th:nth-child(6),
  .eg-print-root .items-table.cols-ventas-progress td:nth-child(6) { width: 12%; }
  .eg-print-root .print-footer {
    margin-top: 5mm;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 12px;
  }
  .eg-print-root .print-footer-obs {
    flex: 1 1 52%;
    font-size: 7.5pt;
  }
  .eg-print-root .print-obs-label {
    font-weight: 700;
    color: #0d9488;
    margin-bottom: 2px;
  }
  .eg-print-root .print-obs-text {
    font-size: 7pt;
    color: #374151;
    white-space: pre-wrap;
    word-wrap: break-word;
    line-height: 1.25;
  }
  .eg-print-root .print-footer-total {
    flex: 0 0 auto;
    text-align: right;
    font-size: 7.5pt;
    min-width: 100px;
  }
  .eg-print-root .print-total-label {
    font-weight: 700;
    color: #0d9488;
    margin-right: 6px;
  }
  .eg-print-root .print-total-value {
    color: #374151;
    font-weight: 600;
  }
  .eg-print-root .print-footer-total .print-total-row {
    margin-bottom: 1px;
    white-space: nowrap;
  }
  .eg-print-root .print-footer-total .print-total-row-final .print-total-value {
    font-weight: 700;
    color: #0d9488;
  }
  .eg-print-root .print-totals-words {
    font-size: 6.5pt;
    font-style: italic;
    color: #6b7280;
    margin-top: 3px;
    line-height: 1.2;
    max-width: 48mm;
    margin-left: auto;
    text-align: right;
  }
`;

export const ENTRY_GUIDE_PRINT_PAGE_STYLES = `
  @page { size: A4; margin: 10mm; }
  @media print {
    * { -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; }
    body { margin: 0; padding: 0; background: white; }
    .no-print { display: none !important; }
    .eg-print-root .print-container { padding: 0; margin: 0; max-width: 100%; box-shadow: none; width: 100%; }
  }
  @media screen {
    body { background: #f3f4f6; }
    .eg-print-root .print-container {
      max-width: 210mm;
      margin: 20px auto;
      background: white;
      box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
    }
    .print-actions {
      position: fixed;
      top: 20px;
      right: 20px;
      z-index: 1000;
      display: flex;
      gap: 10px;
    }
  }
  @media print {
    .eg-print-root .section-title {
      page-break-after: avoid;
      break-after: avoid-page;
    }
    .eg-print-root .items-table thead {
      display: table-header-group;
    }
    .eg-print-root .items-table tbody tr {
      page-break-inside: avoid;
      break-inside: avoid-page;
    }
    .eg-print-root .print-footer {
      page-break-inside: avoid;
      break-inside: avoid-page;
      page-break-before: avoid;
      break-before: avoid-page;
      margin-top: 3mm;
      display: block;
    }
    .eg-print-root .print-footer-total {
      text-align: right;
      margin-top: 2mm;
    }
  }
`;
